<template>
  <div :key='key'>
    <slot name='default' />
  </div>
</template>

<script>
export default {
  name: 'ResizeListener',
  props: {
    renderAfterResize: { type: Boolean, default: true }
  },
  data() {
    return {
      key: 0
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    this.cleanup();
  },
  deactivated() {
    this.cleanup();
  },
  methods: {
    reRender() {
      this.key += 1;
    },
    handleResize() {
      if (this.renderAfterResize) { this.reRender() }
      this.$emit('resize');
    },
    cleanup() {
      window.removeEventListener("resize", this.handleResize);
    },
  }
};
</script>
